/* Diccionario de traducciones ES/EN.
   Para añadir nuevas: agrega la clave en ambos idiomas. Si falta, devuelve la clave.
*/
export const DICT = {
  es: {
    // Comunes
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.edit": "Editar",
    "common.delete": "Eliminar",
    "common.remove": "Quitar",
    "common.add": "Añadir",
    "common.new": "Nuevo",
    "common.search": "Buscar",
    "common.loading": "Cargando…",
    "common.back": "Atrás",
    "common.yes": "Sí",
    "common.no": "No",
    "common.from": "Desde",
    "common.to": "Hasta",
    "common.total": "Total",
    "common.actions": "Acciones",
    "common.status": "Estado",
    "common.date": "Fecha",
    "common.hours": "Horas",
    "common.test": "Probar",
    "common.testing": "Probando…",
    "common.saving": "Guardando…",
    "common.close": "Cerrar",
    "common.required": "Requerido",
    "common.optional": "Opcional",
    "common.confirm": "Confirmar",
    "common.clear": "Limpiar",
    "common.select": "Selecciona...",
    "common.all": "Todos",
    "common.active": "Activos",
    "common.inactive": "Inactivos",
    "common.uploading": "Subiendo…",
    "common.error": "Error",

    // Nav
    "nav.dashboard": "Inicio",
    "nav.trabajos": "Trabajos",
    "nav.mantenimientos": "Mantenimientos",
    "nav.embarcaciones": "Propiedades",
    "nav.clientes": "Clientes",
    "nav.servicios": "Servicios",
    "nav.usuarios": "Empleados",
    "nav.calendario": "Calendario",
    "nav.agenda": "Agenda",
    "nav.albaranes": "Albaranes",
    "nav.leads": "Leads",
    "nav.horas": "Horas equipo",
    "nav.ajustes": "Ajustes",
    "nav.perfil": "Opciones",
    "nav.logout": "Cerrar sesión",
    "nav.principal": "Principal",
    "nav.gestion": "Gestión",

    // Login
    "login.welcome": "Bienvenido/a",
    "login.subtitle": "Introduce tus credenciales para acceder.",
    "login.email": "Email",
    "login.password": "Contraseña",
    "login.show_password": "Mostrar contraseña",
    "login.hide_password": "Ocultar contraseña",
    "login.submit": "Acceder",
    "login.submitting": "Accediendo...",
    "login.demo_version": "Versión Demo · Mallorca 2026",
    "login.hero_tag": "Mallorca · Premium cleaning",
    "login.hero_title": "Gestión sin fricciones para tu flota y villas.",
    "login.hero_desc": "Programa mantenimientos, asigna equipos, registra partes con foto y firma. Todo en un mismo sitio.",
    "login.deactivated_msg": "Tu sesión se ha cerrado porque tu usuario ha sido desactivado. Contacta con el administrador.",
    "login.choose_lang": "Idioma",
    "login.forgot_password": "¿Has olvidado tu contraseña?",

    // Forgot password
    "forgot.title": "Recuperar contraseña",
    "forgot.subtitle": "Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.",
    "forgot.submit": "Enviar enlace de recuperación",
    "forgot.sending": "Enviando...",
    "forgot.sent_title": "Revisa tu email",
    "forgot.sent_desc": "Si tu email está registrado, recibirás un enlace para restablecer tu contraseña en los próximos minutos.",
    "forgot.check_spam": "¿No lo ves? Revisa la carpeta de spam.",
    "forgot.back_to_login": "Volver al inicio de sesión",

    // Reset password
    "reset.checking": "Verificando enlace...",
    "reset.title": "Nueva contraseña",
    "reset.subtitle": "Vas a cambiar la contraseña de la cuenta",
    "reset.new_password": "Nueva contraseña",
    "reset.confirm_password": "Confirmar contraseña",
    "reset.submit": "Guardar nueva contraseña",
    "reset.saving": "Guardando...",
    "reset.min_length": "La contraseña debe tener al menos 6 caracteres.",
    "reset.mismatch": "Las contraseñas no coinciden.",
    "reset.invalid_title": "Enlace no válido",
    "reset.invalid_desc": "Este enlace ha caducado o ya se ha utilizado. Por seguridad, solicita uno nuevo.",
    "reset.request_new": "Solicitar nuevo enlace",
    "reset.done_title": "Contraseña actualizada",
    "reset.done_desc": "Ya puedes iniciar sesión con tu nueva contraseña.",
    "reset.redirecting": "Te llevamos al login...",

    // Greetings
    "greet.morning": "Buenos días",
    "greet.afternoon": "Buenas tardes",
    "greet.evening": "Buenas noches",
    "greet.hello": "Hola",

    // Inicio
    "inicio.stat.today": "Hoy",
    "inicio.stat.scheduled": "Programados",
    "inicio.stat.in_progress": "En curso",
    "inicio.stat.completed": "Completados",
    "inicio.today_jobs": "Trabajos de hoy",
    "inicio.see_all": "Ver todos",
    "inicio.no_jobs": "No hay trabajos para hoy ni en curso.",
    "inicio.quick_actions": "Gestión rápida",
    "inicio.calendar.my_hours": "Trabajos y horas del mes",
    "inicio.calendar.total_month": "Total horas del mes",
    "inicio.day": "Día",
    "inicio.start": "Inicio",
    "inicio.end": "Fin",
    "inicio.pause": "Pausa",
    "inicio.worked": "Trabajadas",
    "inicio.day_total_pause": "Pausa total del día",
    "inicio.day_total_worked": "Horas trabajadas del día",

    // Trabajos
    "trabajos.title": "Mantenimientos",
    "trabajos.count": "{n} registrados",
    "trabajos.filter.scheduled": "Programados",
    "trabajos.filter.in_progress": "En curso",
    "trabajos.filter.completed": "Completados",
    "trabajos.empty.title": "Sin mantenimientos",
    "trabajos.empty.sub": "No hay mantenimientos para este filtro.",
    "trabajos.manage_services": "Gestionar servicios",
    "trabajos.calendar": "Calendario",
    "trabajos.new": "Nuevo mantenimiento",

    // Status
    "status.programado": "Programado",
    "status.en_curso": "En curso",
    "status.pausado": "Pausado",
    "status.finalizado": "Completado",
    "status.retraso": "Con retraso",

    // Perfil
    "perfil.title": "Opciones",
    "perfil.role.admin": "ADMINISTRADOR",
    "perfil.role.empleado": "EMPLEADO",
    "perfil.rate": "Tarifa:",
    "perfil.rate.per_hour": "€/hora",
    "perfil.section.time": "MI TIEMPO",
    "perfil.section.management": "GESTIÓN",
    "perfil.team_hours": "Horas de equipo",
    "perfil.my_hours": "Mis horas",
    "perfil.hours.sub": "Calendario mensual e histórico",
    "perfil.gestion.agenda": "Agenda",
    "perfil.gestion.agenda.sub": "Calendario mes/semana/día",
    "perfil.gestion.clientes": "Clientes",
    "perfil.gestion.clientes.sub": "Gestionar clientes",
    "perfil.gestion.servicios": "Servicios",
    "perfil.gestion.servicios.sub": "Servicios y precios",
    "perfil.gestion.embarcaciones": "Propiedades",
    "perfil.gestion.embarcaciones.sub": "Chalets y embarcaciones",
    "perfil.gestion.usuarios": "Empleados",
    "perfil.gestion.usuarios.sub": "Equipo y permisos",
    "perfil.gestion.informes": "Informes",
    "perfil.gestion.informes.sub": "Horas por trabajador",

    // Mis horas
    "horas.title.admin": "Horas del equipo",
    "horas.title.empleado": "Mis horas",
    "horas.employee": "Empleado",
    "horas.choose_employee": "— Elige un empleado —",
    "horas.summary.hours": "Horas",
    "horas.summary.services": "Servicios",
    "horas.summary.total": "Total",
    "horas.click_day_hint": "Haz clic en un día con horas para ver los servicios realizados.",
    "horas.daily_summary": "Resumen diario",
    "horas.services_done": "Trabajos realizados",
    "horas.observations": "Observaciones",
    "horas.no_services": "Sin servicios marcados como realizados.",
    "horas.see_full": "Ver mantenimiento completo →",
    "horas.no_items_day": "Sin mantenimientos en este día.",
    "horas.service_count_one": "servicio",
    "horas.service_count_many": "servicios",

    // Detalle Trabajo
    "detalle.tag": "Mantenimiento",
    "detalle.client": "Cliente",
    "detalle.scheduled": "Programado",
    "detalle.start_planned": "Inicio prev.",
    "detalle.end_planned": "Fin prev.",
    "detalle.location": "Ubicación",
    "detalle.employees": "Empleados",
    "detalle.plate": "Matrícula",
    "detalle.observations": "Observaciones",
    "detalle.observations.placeholder": "Notas del servicio, instrucciones para el equipo...",
    "detalle.observations.empty": "Sin observaciones.",
    "detalle.add": "Añadir",
    "detalle.edit": "Editar",
    "detalle.services": "Servicios",
    "detalle.mark_all": "✓ Marcar todos",
    "detalle.no_assigned": "Sin servicios asignados. Pulsa \"Añadir\" para asignar uno.",
    "detalle.warning_not_billable": "⚠ Este servicio no se facturará. No hay ningún servicio marcado como \"realizado\". Marca al menos uno (o pulsa ✓ Marcar todos) para que aparezca importe en albaranes y Holded.",
    "detalle.checklist.title": "Checklist de zonas",
    "detalle.checklist.required": "OBLIGATORIA",
    "detalle.checklist.completed": "COMPLETADA",
    "detalle.checklist.hint": "⚠ Debes marcar todas las zonas para poder finalizar el servicio.",
    "detalle.photos.title": "Fotos del servicio",
    "detalle.photos.empty": "Sin fotos. Añade fotos del trabajo realizado.",
    "detalle.photos.add": "Añadir",
    "detalle.photos.new": "Nueva foto",
    "detalle.photos.comment": "Comentario (opcional)",
    "detalle.photos.comment.placeholder": "Ej: Cristales rotos en cubierta, manchas en el sofá...",
    "detalle.photos.no_comment": "Sin comentario",
    "detalle.photos.confirm_delete": "¿Eliminar esta foto?",
    "detalle.incidents.title": "Incidencias",
    "detalle.incidents.placeholder": "Describe cualquier problema encontrado: roturas, suciedad excepcional, falta de material...",
    "detalle.incidents.empty": "Sin incidencias registradas. Pulsa \"Añadir\" para anotar una.",
    "detalle.btn.start": "Iniciar servicio (con GPS)",
    "detalle.btn.pause": "Pausar",
    "detalle.btn.resume": "Reanudar",
    "detalle.btn.finish": "Finalizar",
    "detalle.btn.finish_hint": "Completa la checklist ({done}/{total}) para poder finalizar.",
    "detalle.btn.emit_holded": "📄 Emitir presupuesto en Holded",
    "detalle.btn.holded.ok": "✓ Presupuesto creado en Holded (id: {id})",
    "detalle.btn.holded.no_key": "⚠ Configura tu API key de Holded en Ajustes para emitir presupuestos.",
    "detalle.btn.delete": "Eliminar",
    "detalle.confirm.delete": "¿Eliminar este mantenimiento?",
    "detalle.confirm.remove_service": "¿Quitar este servicio de la lista?",
    "detalle.add_service": "Añadir servicio",
    "detalle.all_assigned": "Todos los servicios disponibles ya están asignados.",
    "detalle.real_hours": "Horas reales",
    "detalle.real_start": "Inicio real",
    "detalle.real_end": "Fin real",
    "detalle.worked_label": "Trabajadas",
    "detalle.pause_label": "Pausa",
    "detalle.real_hours.hint": "Las horas trabajadas se usan para calcular los importes de albaranes y presupuestos Holded.",
    "detalle.real_hours.input_hint": "Ej: 1.5 = 1h 30min · 0.25 = 15min",
    "detalle.in_progress_warn": "⚠ Servicio aún en curso o pausado.",
    "detalle.hours_worked": "Horas trabajadas",
    "detalle.pause_hours": "Horas de pausa",
    "detalle.remove_service_aria": "Quitar servicio",
    "detalle.start_planned_label": "Inicio prev.",

    // Mantenimiento Form
    "mform.edit": "Editar mantenimiento",
    "mform.new": "Nuevo mantenimiento",
    "mform.property": "Embarcación / Chalet",
    "mform.status": "Estado",
    "mform.start_dt": "Fecha y hora de inicio",
    "mform.end_dt": "Fecha y hora de finalización",
    "mform.workers": "Trabajadores asignados",
    "mform.you": "Tú",
    "mform.services": "Servicios",
    "mform.col.assign": "Asig.",
    "mform.col.service": "Servicio",
    "mform.col.price": "Precio",
    "mform.col.done": "Realizado",
    "mform.special": "ESPECIAL",
    "mform.obs": "Observaciones",
    "mform.obs.admin_only": "Observaciones (del administrador)",
    "mform.obs.placeholder": "Notas internas para el equipo...",
    "mform.obs.empty": "Sin observaciones del administrador.",
    "mform.save_edit": "Guardar cambios",
    "mform.save_new": "Crear mantenimiento",
    "mform.client_label": "Cliente:",

    // Embarcaciones
    "emb.title": "Embarcaciones",
    "emb.count": "{n} registradas",
    "emb.search.placeholder": "Buscar por nombre, matrícula, puerto...",
    "emb.empty.title": "Sin embarcaciones",
    "emb.empty.sub": "No se encontraron resultados.",
    "emb.manage": "Gestionar embarcaciones y checklists",

    // Calendar
    "cal.title": "Agenda de mantenimientos",
    "cal.allDay": "Todo el día",
    "cal.previous": "Anterior",
    "cal.next": "Siguiente",
    "cal.today": "Hoy",
    "cal.month": "Mes",
    "cal.week": "Semana",
    "cal.day": "Día",
    "cal.agenda": "Agenda",
    "cal.date": "Fecha",
    "cal.time": "Hora",
    "cal.event": "Mantenimiento",
    "cal.empty_range": "No hay mantenimientos en este rango.",
    "cal.show_more": "+ {n} más",
    "cal.legend.programado": "PROGRAMADO",
    "cal.legend.en_curso": "EN CURSO",
    "cal.legend.finalizado": "FINALIZADO",
    "cal.legend.retraso": "RETRASO",

    // Settings (already existing keys)
    "settings.title": "Ajustes",
    "settings.tab.empresa": "Datos de empresa",
    "settings.tab.holded": "Integración Holded",
    "settings.tab.idioma": "Idioma",
    "settings.empresa.nombre": "Razón social",
    "settings.empresa.cif": "CIF / NIF",
    "settings.empresa.direccion": "Dirección",
    "settings.empresa.cp": "Código postal",
    "settings.empresa.poblacion": "Población",
    "settings.empresa.provincia": "Provincia",
    "settings.empresa.pais": "País",
    "settings.empresa.telefono": "Teléfono",
    "settings.empresa.email": "Email",
    "settings.empresa.apartado": "Apartado de correos",
    "settings.empresa.web": "Web",
    "settings.empresa.logo": "Logo (URL)",
    "settings.empresa.title": "Datos fiscales y de contacto",
    "settings.empresa.desc": "Esta información aparecerá en presupuestos y comunicaciones generadas por la app.",
    "settings.empresa.saved": "Datos de empresa guardados",
    "settings.holded.title": "Conexión con Holded",
    "settings.holded.desc": "Configura tu API Key de Holded. Se almacena cifrada y solo administradores pueden verla.",
    "settings.holded.howto": "¿Cómo obtener tu API Key?",
    "settings.holded.howto_steps": "Holded → Configuración (arriba izquierda) → Más → Desarrolladores → '+ Nueva API Key' → Copia el código generado.",
    "settings.holded.mode": "Modo",
    "settings.holded.mode.real": "Real (envía a tu Holded)",
    "settings.holded.mode.mock": "Simulación (no envía nada)",
    "settings.holded.key": "API Key",
    "settings.holded.key.placeholder": "Pega aquí la API Key…",
    "settings.holded.key.current": "Actual",
    "settings.holded.key.empty": "(sin configurar)",
    "settings.holded.key.hint": "Deja en blanco para mantener la actual.",
    "settings.holded.base_url": "URL base API",
    "settings.holded.tax": "IVA por defecto (%)",
    "settings.holded.test": "Probar conexión",
    "settings.holded.saved": "Configuración Holded guardada",
    "settings.lang.title": "Idioma de la aplicación",
    "settings.lang.desc": "Cambia el idioma en cualquier momento. Se aplicará al instante en toda la app.",
    "settings.lang.es": "Español",
    "settings.lang.en": "English",

    // Plan / Suscripción
    "plan.title": "Mi plan",
    "plan.section": "PLAN",
    "plan.current": "Plan actual",
    "plan.free": "Free",
    "plan.pro": "Pro",
    "plan.trial": "Prueba",
    "plan.trial.days_left_one": "Te queda {n} día de prueba",
    "plan.trial.days_left_many": "Te quedan {n} días de prueba",
    "plan.trial.ends_today": "¡Hoy termina tu prueba gratuita!",
    "plan.trial.upgrade_cta": "Actualizar a Pro ahora",
    "plan.monthly_title": "Plan Mensual",
    "plan.annual_title": "Plan Anual",
    "plan.trial_title": "Prueba gratuita",
    "plan.active": "Activa",
    "plan.grandfathered": "Plan Pro",
    "plan.usage": "Uso actual",
    "plan.properties": "Propiedades",
    "plan.employees": "Empleados",
    "plan.maintenance_month": "Mant./mes",
    "plan.unlimited": "Ilimitado",
    "plan.upgrade": "Actualizar a Pro",
    "plan.upgrade.title": "Desbloquea todo con Pro",
    "plan.upgrade.desc": "Hasta 50 propiedades, 30 empleados activos, trabajos sin límite, integración Holded, exportaciones, informes avanzados y más.",
    "plan.price.monthly": "€/mes",
    "plan.price.yearly": "€/año",
    "plan.price.yearly.hint": "Ahorra 2 meses",
    "plan.start_trial": "Empezar prueba 14 días",
    "plan.trial_used": "Prueba ya usada",
    "plan.promo": "Código promocional",
    "plan.promo.placeholder": "Introduce tu código",
    "plan.promo.apply": "Aplicar",
    "plan.promo.ok": "Descuento del {pct}% aplicado",
    "plan.promo.invalid": "Código no válido",
    "plan.limit.title": "Has alcanzado el límite",
    "plan.limit.upgrade_now": "Actualiza para continuar",
    "plan.holded_locked": "Emisión Holded requiere Pro",
  },
  en: {
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.remove": "Remove",
    "common.add": "Add",
    "common.new": "New",
    "common.search": "Search",
    "common.loading": "Loading…",
    "common.back": "Back",
    "common.yes": "Yes",
    "common.no": "No",
    "common.from": "From",
    "common.to": "To",
    "common.total": "Total",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.date": "Date",
    "common.hours": "Hours",
    "common.test": "Test",
    "common.testing": "Testing…",
    "common.saving": "Saving…",
    "common.close": "Close",
    "common.required": "Required",
    "common.optional": "Optional",
    "common.confirm": "Confirm",
    "common.clear": "Clear",
    "common.select": "Select…",
    "common.all": "All",
    "common.active": "Active",
    "common.inactive": "Inactive",
    "common.uploading": "Uploading…",
    "common.error": "Error",

    "nav.dashboard": "Home",
    "nav.trabajos": "Jobs",
    "nav.mantenimientos": "Maintenance",
    "nav.embarcaciones": "Properties",
    "nav.clientes": "Customers",
    "nav.servicios": "Services",
    "nav.usuarios": "Staff",
    "nav.calendario": "Calendar",
    "nav.agenda": "Agenda",
    "nav.albaranes": "Delivery notes",
    "nav.leads": "Leads",
    "nav.horas": "Team hours",
    "nav.ajustes": "Settings",
    "nav.perfil": "Options",
    "nav.logout": "Sign out",
    "nav.principal": "Main",
    "nav.gestion": "Management",

    "login.welcome": "Welcome",
    "login.subtitle": "Enter your credentials to continue.",
    "login.email": "Email",
    "login.password": "Password",
    "login.show_password": "Show password",
    "login.hide_password": "Hide password",
    "login.submit": "Sign in",
    "login.submitting": "Signing in…",
    "login.demo_version": "Demo version · Mallorca 2026",
    "login.hero_tag": "Mallorca · Premium cleaning",
    "login.hero_title": "Effortless management for your fleet & villas.",
    "login.hero_desc": "Schedule maintenance, assign teams, log reports with photos and signature. Everything in one place.",
    "login.deactivated_msg": "Your session was closed because your account has been deactivated. Contact the administrator.",
    "login.choose_lang": "Language",
    "login.forgot_password": "Forgot your password?",

    // Forgot password
    "forgot.title": "Reset password",
    "forgot.subtitle": "Enter your email and we'll send you a link to reset your password.",
    "forgot.submit": "Send recovery link",
    "forgot.sending": "Sending...",
    "forgot.sent_title": "Check your email",
    "forgot.sent_desc": "If your email is registered, you'll receive a link to reset your password in the next few minutes.",
    "forgot.check_spam": "Not seeing it? Check your spam folder.",
    "forgot.back_to_login": "Back to sign in",

    // Reset password
    "reset.checking": "Verifying link...",
    "reset.title": "New password",
    "reset.subtitle": "You are about to change the password for account",
    "reset.new_password": "New password",
    "reset.confirm_password": "Confirm password",
    "reset.submit": "Save new password",
    "reset.saving": "Saving...",
    "reset.min_length": "Password must be at least 6 characters long.",
    "reset.mismatch": "Passwords do not match.",
    "reset.invalid_title": "Invalid link",
    "reset.invalid_desc": "This link has expired or has already been used. Please request a new one.",
    "reset.request_new": "Request new link",
    "reset.done_title": "Password updated",
    "reset.done_desc": "You can now sign in with your new password.",
    "reset.redirecting": "Taking you to sign in...",

    "greet.morning": "Good morning",
    "greet.afternoon": "Good afternoon",
    "greet.evening": "Good evening",
    "greet.hello": "Hello",

    "inicio.stat.today": "Today",
    "inicio.stat.scheduled": "Scheduled",
    "inicio.stat.in_progress": "In progress",
    "inicio.stat.completed": "Completed",
    "inicio.today_jobs": "Today's jobs",
    "inicio.see_all": "See all",
    "inicio.no_jobs": "No jobs today or in progress.",
    "inicio.quick_actions": "Quick access",
    "inicio.calendar.my_hours": "Jobs and hours this month",
    "inicio.calendar.total_month": "Monthly total hours",
    "inicio.day": "Day",
    "inicio.start": "Start",
    "inicio.end": "End",
    "inicio.pause": "Pause",
    "inicio.worked": "Worked",
    "inicio.day_total_pause": "Total day pause",
    "inicio.day_total_worked": "Day worked hours",

    "trabajos.title": "Maintenance",
    "trabajos.count": "{n} records",
    "trabajos.filter.scheduled": "Scheduled",
    "trabajos.filter.in_progress": "In progress",
    "trabajos.filter.completed": "Completed",
    "trabajos.empty.title": "No maintenance",
    "trabajos.empty.sub": "No items for this filter.",
    "trabajos.manage_services": "Manage services",
    "trabajos.calendar": "Calendar",
    "trabajos.new": "New maintenance",

    "status.programado": "Scheduled",
    "status.en_curso": "In progress",
    "status.pausado": "Paused",
    "status.finalizado": "Completed",
    "status.retraso": "Delayed",

    "perfil.title": "Options",
    "perfil.role.admin": "ADMIN",
    "perfil.role.empleado": "STAFF",
    "perfil.rate": "Rate:",
    "perfil.rate.per_hour": "€/hour",
    "perfil.section.time": "MY TIME",
    "perfil.section.management": "MANAGEMENT",
    "perfil.team_hours": "Team hours",
    "perfil.my_hours": "My hours",
    "perfil.hours.sub": "Monthly calendar and history",
    "perfil.gestion.agenda": "Agenda",
    "perfil.gestion.agenda.sub": "Month / week / day calendar",
    "perfil.gestion.clientes": "Customers",
    "perfil.gestion.clientes.sub": "Manage customers",
    "perfil.gestion.servicios": "Services",
    "perfil.gestion.servicios.sub": "Services and prices",
    "perfil.gestion.embarcaciones": "Properties",
    "perfil.gestion.embarcaciones.sub": "Villas and boats",
    "perfil.gestion.usuarios": "Employees",
    "perfil.gestion.usuarios.sub": "Team and permissions",
    "perfil.gestion.informes": "Reports",
    "perfil.gestion.informes.sub": "Hours per worker",

    "horas.title.admin": "Team hours",
    "horas.title.empleado": "My hours",
    "horas.employee": "Employee",
    "horas.choose_employee": "— Choose an employee —",
    "horas.summary.hours": "Hours",
    "horas.summary.services": "Services",
    "horas.summary.total": "Total",
    "horas.click_day_hint": "Click on a day with hours to see the services done.",
    "horas.daily_summary": "Daily summary",
    "horas.services_done": "Completed services",
    "horas.observations": "Notes",
    "horas.no_services": "No services marked as done.",
    "horas.see_full": "View full maintenance →",
    "horas.no_items_day": "No maintenance on this day.",
    "horas.service_count_one": "service",
    "horas.service_count_many": "services",

    "detalle.tag": "Maintenance",
    "detalle.client": "Customer",
    "detalle.scheduled": "Scheduled",
    "detalle.start_planned": "Planned start",
    "detalle.end_planned": "Planned end",
    "detalle.location": "Location",
    "detalle.employees": "Staff",
    "detalle.plate": "Reg.",
    "detalle.observations": "Notes",
    "detalle.observations.placeholder": "Service notes, instructions for the team…",
    "detalle.observations.empty": "No notes.",
    "detalle.add": "Add",
    "detalle.edit": "Edit",
    "detalle.services": "Services",
    "detalle.mark_all": "✓ Mark all",
    "detalle.no_assigned": "No services assigned. Press \"Add\" to assign one.",
    "detalle.warning_not_billable": "⚠ This service won't be billed. No service is marked as \"done\". Mark at least one (or press ✓ Mark all) so an amount appears in delivery notes and Holded.",
    "detalle.checklist.title": "Areas checklist",
    "detalle.checklist.required": "REQUIRED",
    "detalle.checklist.completed": "COMPLETED",
    "detalle.checklist.hint": "⚠ You must check all areas before completing the service.",
    "detalle.photos.title": "Service photos",
    "detalle.photos.empty": "No photos. Add photos of the work done.",
    "detalle.photos.add": "Add",
    "detalle.photos.new": "New photo",
    "detalle.photos.comment": "Comment (optional)",
    "detalle.photos.comment.placeholder": "E.g. broken glass on deck, stains on couch…",
    "detalle.photos.no_comment": "No comment",
    "detalle.photos.confirm_delete": "Delete this photo?",
    "detalle.incidents.title": "Incidents",
    "detalle.incidents.placeholder": "Describe any issue: damage, exceptional dirt, missing supplies…",
    "detalle.incidents.empty": "No incidents reported. Press \"Add\" to log one.",
    "detalle.btn.start": "Start service (with GPS)",
    "detalle.btn.pause": "Pause",
    "detalle.btn.resume": "Resume",
    "detalle.btn.finish": "Finish",
    "detalle.btn.finish_hint": "Complete the checklist ({done}/{total}) to finish.",
    "detalle.btn.emit_holded": "📄 Issue quote in Holded",
    "detalle.btn.holded.ok": "✓ Quote created in Holded (id: {id})",
    "detalle.btn.holded.no_key": "⚠ Configure your Holded API key in Settings to issue quotes.",
    "detalle.btn.delete": "Delete",
    "detalle.confirm.delete": "Delete this maintenance?",
    "detalle.confirm.remove_service": "Remove this service from the list?",
    "detalle.add_service": "Add service",
    "detalle.all_assigned": "All available services are already assigned.",
    "detalle.real_hours": "Real hours",
    "detalle.real_start": "Real start",
    "detalle.real_end": "Real end",
    "detalle.worked_label": "Worked",
    "detalle.pause_label": "Pause",
    "detalle.real_hours.hint": "Worked hours are used to calculate amounts for delivery notes and Holded quotes.",
    "detalle.real_hours.input_hint": "E.g. 1.5 = 1h 30min · 0.25 = 15min",
    "detalle.in_progress_warn": "⚠ Service still in progress or paused.",
    "detalle.hours_worked": "Worked hours",
    "detalle.pause_hours": "Pause hours",
    "detalle.remove_service_aria": "Remove service",
    "detalle.start_planned_label": "Planned start",

    "mform.edit": "Edit maintenance",
    "mform.new": "New maintenance",
    "mform.property": "Property / Boat",
    "mform.status": "Status",
    "mform.start_dt": "Start date & time",
    "mform.end_dt": "End date & time",
    "mform.workers": "Assigned workers",
    "mform.you": "You",
    "mform.services": "Services",
    "mform.col.assign": "Assg.",
    "mform.col.service": "Service",
    "mform.col.price": "Price",
    "mform.col.done": "Done",
    "mform.special": "SPECIAL",
    "mform.obs": "Notes",
    "mform.obs.admin_only": "Notes (from admin)",
    "mform.obs.placeholder": "Internal notes for the team…",
    "mform.obs.empty": "No notes from admin.",
    "mform.save_edit": "Save changes",
    "mform.save_new": "Create maintenance",
    "mform.client_label": "Customer:",

    "emb.title": "Properties",
    "emb.count": "{n} registered",
    "emb.search.placeholder": "Search by name, plate, port…",
    "emb.empty.title": "No properties",
    "emb.empty.sub": "No results found.",
    "emb.manage": "Manage properties and checklists",

    "cal.title": "Maintenance agenda",
    "cal.allDay": "All day",
    "cal.previous": "Previous",
    "cal.next": "Next",
    "cal.today": "Today",
    "cal.month": "Month",
    "cal.week": "Week",
    "cal.day": "Day",
    "cal.agenda": "Agenda",
    "cal.date": "Date",
    "cal.time": "Time",
    "cal.event": "Maintenance",
    "cal.empty_range": "No maintenance in this range.",
    "cal.show_more": "+ {n} more",
    "cal.legend.programado": "SCHEDULED",
    "cal.legend.en_curso": "IN PROGRESS",
    "cal.legend.finalizado": "COMPLETED",
    "cal.legend.retraso": "DELAYED",

    "settings.title": "Settings",
    "settings.tab.empresa": "Company info",
    "settings.tab.holded": "Holded integration",
    "settings.tab.idioma": "Language",
    "settings.empresa.nombre": "Business name",
    "settings.empresa.cif": "Tax ID",
    "settings.empresa.direccion": "Address",
    "settings.empresa.cp": "Postal code",
    "settings.empresa.poblacion": "City",
    "settings.empresa.provincia": "Province / State",
    "settings.empresa.pais": "Country",
    "settings.empresa.telefono": "Phone",
    "settings.empresa.email": "Email",
    "settings.empresa.apartado": "PO Box",
    "settings.empresa.web": "Website",
    "settings.empresa.logo": "Logo (URL)",
    "settings.empresa.title": "Tax & contact info",
    "settings.empresa.desc": "This info will appear on quotes and app-generated communications.",
    "settings.empresa.saved": "Company info saved",
    "settings.holded.title": "Holded connection",
    "settings.holded.desc": "Configure your Holded API Key. Stored securely; only admins can view it.",
    "settings.holded.howto": "How to get your API Key?",
    "settings.holded.howto_steps": "Holded → Settings (top left) → More → Developers → 'New API Key' → Copy the generated code.",
    "settings.holded.mode": "Mode",
    "settings.holded.mode.real": "Real (sends to your Holded)",
    "settings.holded.mode.mock": "Simulation (does not send)",
    "settings.holded.key": "API Key",
    "settings.holded.key.placeholder": "Paste API Key here…",
    "settings.holded.key.current": "Current",
    "settings.holded.key.empty": "(not configured)",
    "settings.holded.key.hint": "Leave blank to keep current key.",
    "settings.holded.base_url": "API base URL",
    "settings.holded.tax": "Default VAT (%)",
    "settings.holded.test": "Test connection",
    "settings.holded.saved": "Holded settings saved",
    "settings.lang.title": "App language",
    "settings.lang.desc": "Change language at any time. Applied instantly across the app.",
    "settings.lang.es": "Spanish",
    "settings.lang.en": "English",

    "plan.title": "My plan",
    "plan.section": "PLAN",
    "plan.current": "Current plan",
    "plan.free": "Free",
    "plan.pro": "Pro",
    "plan.trial": "Trial",
    "plan.trial.days_left_one": "{n} day left of your trial",
    "plan.trial.days_left_many": "{n} days left of your trial",
    "plan.trial.ends_today": "Your free trial ends today!",
    "plan.trial.upgrade_cta": "Upgrade to Pro now",
    "plan.monthly_title": "Monthly Plan",
    "plan.annual_title": "Annual Plan",
    "plan.trial_title": "Free Trial",
    "plan.active": "Active",
    "plan.grandfathered": "Pro Plan",
    "plan.usage": "Current usage",
    "plan.properties": "Properties",
    "plan.employees": "Staff",
    "plan.maintenance_month": "Jobs/month",
    "plan.unlimited": "Unlimited",
    "plan.upgrade": "Upgrade to Pro",
    "plan.upgrade.title": "Unlock everything with Pro",
    "plan.upgrade.desc": "Up to 50 properties, 30 active employees, unlimited jobs, Holded integration, exports, advanced reports and more.",
    "plan.price.monthly": "€/month",
    "plan.price.yearly": "€/year",
    "plan.price.yearly.hint": "Save 2 months",
    "plan.start_trial": "Start 14-day trial",
    "plan.trial_used": "Trial already used",
    "plan.promo": "Promo code",
    "plan.promo.placeholder": "Enter your code",
    "plan.promo.apply": "Apply",
    "plan.promo.ok": "{pct}% discount applied",
    "plan.promo.invalid": "Invalid code",
    "plan.limit.title": "Limit reached",
    "plan.limit.upgrade_now": "Upgrade to continue",
    "plan.holded_locked": "Holded requires Pro",
  },
};
